import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const BRANCH_RESTORE_RESOURCE = "branch" as const;
export const BRANCH_RESTORE_API_PATH = `/v1/${BRANCH_RESTORE_RESOURCE}/{uuid}/restore` as const;

export type BranchRestoreResponse =
  paths[typeof BRANCH_RESTORE_API_PATH]["patch"]["responses"][200]["content"]["application/json"];

export const useBranchRestoreMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<BranchRestoreResponse, Error, { uuid: string }>({
    mutationFn: async ({ uuid }) => {
      const response = await alphartisApiAxios.patch<BranchRestoreResponse>(
        `/v1/${BRANCH_RESTORE_RESOURCE}/${uuid}/restore`,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [BRANCH_RESTORE_RESOURCE, "search"],
      });
    },
  });
};
